import PageProtected from "../../../../components/Page/PageProtected";
import SectionDashboard from "../../../../components/Section/SectionDashboard";
import SectionGeneticsSearch from "./GeneSearch/SectionGeneticsSearch"
import SectionIgv from "./IGV/SectionIgv";
import SectionDisclaimer from "../../../../components/Disclaimer/SectionDisclaimer";

import { useTheme } from "@mui/material";

export default function SearchWelcome() {

    const theme = useTheme();

return (
<>
    <PageProtected
    
    headline="GENETICS - " 
    specify ="EXPLORE AND VISUALIZE"

    main={<> 

    {theme.palette.mode === "light" ? (

        <SectionDashboard

            colorContainer="transparent"

            colorSection_1="grey.C300"
            Section_1={ <SectionGeneticsSearch /> }

            colorSection_2="grey.C400"
            Section_2={ <SectionIgv /> }
            
            colorSection_3="grey.C100"
            Section_3={  <SectionDisclaimer />  }

            colorSection_4="primary.C200"
            Section_4={""}

        />

):(

    <SectionDashboard

            colorContainer="transparent"

            colorSection_1="greydark.C600"
            Section_1={ <SectionGeneticsSearch /> }

            colorSection_2="greydark.C700"
            Section_2={  <SectionIgv /> }
            
            colorSection_3="greydark.C800"
           Section_3={  <SectionDisclaimer />  }

            colorSection_4="greydark.C900"
            Section_4={""}
        />
        )}
    </>
    }
/>

</>
)
}